import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Map = () => {
  return (
    <section id="map" className="py-24 bg-white relative">
      <div className="container-custom">
        {/* Screenshot-style Heading */}
        <div className="flex items-center gap-3 mb-8">
          <MapPin className="w-8 h-8 text-luxury-black fill-luxury-black/10" />
          <h2 className="text-3xl font-serif text-luxury-black">Hyderabad</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12">
          {/* Map Side - Clean Standard Embed */}
          <div className="w-full lg:w-2/3 h-[500px] rounded-xl overflow-hidden shadow-xl border border-gray-100 bg-gray-50 flex items-center justify-center">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15230.134327244!2d78.4795246!3d17.3742461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb98463e260909%3A0xc3317c8088001e35!2sMalakpet%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1714050000000!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Malakpet Map"
            ></iframe>
          </div>

          {/* Info Side */}
          <div className="w-full lg:w-1/3 flex flex-col justify-center">
            <h3 className="text-4xl font-serif text-luxury-black mb-8 leading-tight">
              In the Heart of <br/>Malakpet
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-orange-500 mt-1" />
                <div>
                  <h4 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-1">Our Location</h4>
                  <p className="text-gray-600 font-light leading-relaxed">
                    GPHUB Luxury Suites, <br/>
                    Malakpet, Hyderabad, <br/>
                    Telangana 500036
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-5 h-5 text-orange-500 mt-1" />
                <div>
                  <h4 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-1">Contact</h4>
                  <p className="text-gray-600 font-light leading-relaxed">+91 40 1234 5678</p>
                </div>
              </div>

              <button 
                onClick={() => window.open('https://maps.app.goo.gl/YourMalakpetLink', '_blank')}
                className="btn-gold w-full mt-8 rounded-xl py-4"
              >
                GET DIRECTIONS
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Map;
